<template>
  <div
    class="card card_white flex-fill justify-content-center"
    v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
  >
    <div
      class="d-flex align-items-center"
      style="justify-content: space-between"
    >
      <div>
        <div class="sub_title_2" v-if="param != null">
          {{ param.metricName }}
        </div>
        <div v-if="param != null" style="font-size: 24px; font-weight: bold">
          {{ formattedNumber(param.value) }}
        </div>
        <div>{{ param.description }}</div>
        <div style="color:#4E4E4E; font-size: 12px;">RUPTL: {{ formattedNumber(param.ruptl) }} MW</div>
        <div style="color:#4E4E4E; font-size: 12px;">{{ param.year }}</div>
      </div>
      <div>
        <img
          @mouseover="hover"
          @mouseleave="afterHover"
          :class="{ hovered: isHovered }"
          @click="showGraph"
          style="cursor: pointer"
          :src="imgDetail"
        />
        <!-- <button
          @mouseover="hover"
          @mouseleave="afterHover"
          :class="{ hovered: isHovered }"
          class="naked_button"
          @click="showGraph"
        >
          <img :src="imgDetail" />
        </button> -->
      </div>
    </div>
  </div>
</template>
<script>
import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

export default {
  components: {
    IconSvg,
  },
  data() {
    return {
      isHovered: false,
      imgDetail: require("@/assets/images/a/chart_icon.svg"),
    };
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  mounted() {},
  methods: {
    hover() {
      this.isHovered = true;
      this.imgDetail = require("@/assets/images/a/chart_icon_active.svg");
    },
    afterHover() {
      this.imgDetail = require("@/assets/images/a/chart_icon.svg");
    },
    
    showGraph() {
      this.$emit("showGraph", this.filter);
    },
    calculateRuptl(value) {
      var d = Math.floor(Math.log10(value));
      var ceilNumber = Math.ceil(value / Math.pow(10, d)) * Math.pow(10, d);

      return ceilNumber;
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.hovered {
  transform: scale(1.1); /* Example of hover effect */
  /* Add any other styles you want to apply on hover */
}
</style>
